import { render, staticRenderFns } from "./ProjectUploadBomModal.vue?vue&type=template&id=564188b3&"
import script from "./ProjectUploadBomModal.vue?vue&type=script&lang=js&"
export * from "./ProjectUploadBomModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('564188b3')) {
      api.createRecord('564188b3', component.options)
    } else {
      api.reload('564188b3', component.options)
    }
    module.hot.accept("./ProjectUploadBomModal.vue?vue&type=template&id=564188b3&", function () {
      api.rerender('564188b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/portfolio/projects/ProjectUploadBomModal.vue"
export default component.exports